import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight, FiShield, FiTruck } from "react-icons/fi";
import { siteConfig } from "../Datas/productData";
import "../css/footer.scss";

function Footer() {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="site-footer" role="contentinfo">
      <section className="site-footer__intro" aria-labelledby="footer-intro-heading">
        <div>
          <p>Made for everyday creativity</p>
          <h2 id="footer-intro-heading">Thoughtful tools, clear details and helpful support when you need it.</h2>
        </div>
        <Link className="site-footer__contact-cta" to="/contact" onClick={toTop}>
          Contact our team <FiArrowRight />
        </Link>
      </section>

      <div className="site-footer__grid">
        <section>
          <h3>Information</h3>
          <Link to="/contact" onClick={toTop}>Customer service</Link>
          <Link to="/about" onClick={toTop}>About us</Link>
          <Link to="/shipping" onClick={toTop}>Delivery & payment</Link>
          <Link to="/returns" onClick={toTop}>Returns</Link>
          <Link to="/terms" onClick={toTop}>Terms & conditions</Link>
          <Link to="/privacy" onClick={toTop}>Privacy policy</Link>
          <Link to="/cookies" onClick={toTop}>Cookie policy</Link>
          <Link to="/faqs" onClick={toTop}>FAQs</Link>
        </section>

        <section>
          <h3>Categories</h3>
          {siteConfig.nav.slice(1).map((item) => (
            <Link
              key={item.label}
              to={`/shop?category=${encodeURIComponent(item.category)}`}
              onClick={toTop}
            >
              {item.label}
            </Link>
          ))}
          <Link to="/shop?new=true" onClick={toTop}>New arrivals</Link>
        </section>

        <section>
          <h3>Legal &amp; policies</h3>
          <Link to="/legal" onClick={toTop}>Policy centre</Link>
          <Link to="/policies/legal-notice" onClick={toTop}>Legal notice</Link>
          <Link to="/policies/payments" onClick={toTop}>Payment policy</Link>
          <Link to="/policies/orders" onClick={toTop}>Order &amp; cancellation</Link>
          <Link to="/policies/warranty-claims" onClick={toTop}>Warranty &amp; claims</Link>
          <Link to="/policies/product-safety" onClick={toTop}>Product safety</Link>
          <Link to="/policies/intellectual-property" onClick={toTop}>Intellectual property</Link>
          <Link to="/policies/accessibility" onClick={toTop}>Accessibility</Link>
          <Link to="/policies/complaints" onClick={toTop}>Complaints</Link>
        </section>

        <section>
          <h3>Customer service</h3>
          <address className="site-footer__contact-details">
            <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>
            <span>{siteConfig.contact.address}</span>
            <span>Operating country: {siteConfig.operatingCountry}</span>
          </address>
          <p>{siteConfig.contact.hours}</p>
          <p>Prices shown in USD</p>
        </section>

        <section className="site-footer__mark" aria-label={siteConfig.brandName}>
          <div><span>{siteConfig.logoText}</span><b>{siteConfig.tagline}</b></div>
        </section>
      </div>

      <div className="site-footer__payments">
        <div className="site-footer__payment-methods">
          <FiShield />
          <p><strong>Supported payments</strong><span><i>VISA</i><i>Mastercard</i><i>AMEX</i><i>Apple Pay</i><i>Google Pay</i></span></p>
        </div>
        <div><FiTruck /><p><strong>Fast shipping</strong>{siteConfig.shipping.message}</p></div>
      </div>

      <div className="site-footer__legal">
        <span>© {new Date().getFullYear()} {siteConfig.brandName}. All rights reserved.</span>
        <button type="button" onClick={toTop}>Back to top ↑</button>
      </div>
    </footer>
  );
}

export default Footer;
